import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const headingCount = defineStyle({
  color: 'yGray.600',
});

export const regular = defineStyle({
  color: 'yGray.800',
  fontSize: 'sm',
  lineHeight: 'short',
  fontWeight: 'normal',
});

export default defineStyleConfig({
  sizes: {
    medium: {
      fontSize: 'sm',
      lineHeight: 1.8,
    },
  },
  variants: {
    headingCount,
    regular,
    label: (props) => ({
      fontWeight: 'medium',
      color: mode('gray.600', 'gray.400')(props),
      fontSize: 'xs',
    }),
  },
});
